/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-mixins */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import { saveOrDiscard } from '@linc-technologies/linced-common/utils/record-rollback';

export default class GoalController extends Controller.extend(EditPostMixin) {
  @service
  session;

  @service
  store;

  @service
  toaster;

  @service
  strings;

  refreshStates() {}

  @action
  refresh() {
    this.get('model.posts').update();
  }

  @action
  handleRefreshStates() {
    this.model.states.update();
  }

  @action
  updateState(goal, previousState, grade) {
    let awarded = GoalState.DEVELOPING;

    switch (previousState) {
      case GoalState.DEVELOPING:
        awarded = GoalState.SECURE;
        break;
      case GoalState.SECURE:
        awarded = GoalState.NOT_SET;
        break;
    }

    let stateParams = {
      schoolId: this.get('session.school'),
      assessorId: this.get('session.person'),
      personId: this.get('model.person'),
      goalId: goal,
      awarded,
    };

    if (!isEmpty(grade)) {
      stateParams.grade = grade;
    }
    let newState = this.store.createRecord('goals/state', stateParams);
    saveOrDiscard(newState)
      .then(() => {
        this.model.states.update();
      })
      .catch(() => this.toaster.error('Error saving the goal state.'));
  }
}
